export default function ($http) {
    return function (vehicleId, mileageId, excluded) {
        const state = excluded ? 'exclude' : 'include';

        return $http.put(`api/vehicles/${ vehicleId }/mileages/${ mileageId }/${ state }`);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/mileages/updateMileageExcludedStatus.js